<template>
  <v-card>
    <!-- <v-card-title class="headline pink white--text">
          {{ currentDocument.fileName }}
        </v-card-title> -->
    <v-card-text style="height: 60em">
      <vue-pdf-app
        :pdf="currentDocument.contentDocument"
        :file-name="currentDocument.fileName"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import VuePdfApp from 'vue-pdf-app'
// import this to use default icons for buttons
import 'vue-pdf-app/dist/icons/main.css'

export default {
  props: {
    currentDocument: {
      type: Object,
    },
  },
  components: {
    VuePdfApp,
  },
}
</script>
